<div
  class="horizontalMenucontainer"
  [ngClass]="{ 'content-bg-primary': mode == 'dark' }"
>
  <div class="page">
    <div class="page-main">
      <app-header [isDarkMode]="mode == 'dark'"></app-header>
      <app-sidebar appHoverEffectSidebar></app-sidebar>
      <div class="jumps-prevent" style="padding-top: 74px"></div>

      <div
        class="app-content main-content"
        [ngClass]="{ 'app-content-bg-primary': mode == 'dark' }"
      >
        <div [ngClass]="{ 'pt-60': scrolled, 'side-app': mode != 'dark' }">
          <div
            class="main-container"
            [ngClass]="{ 'container-fluid': mode == 'dark' }"
            id="custom-main-container"
          >
            <router-outlet>
              <app-loader></app-loader>
            </router-outlet>
          </div>
        </div>
      </div>

      <app-footer></app-footer>
    </div>
  </div>

  <app-tab-to-top></app-tab-to-top>
</div>

<!-- CHANGE PASSWORD MODAL-->
<ng-template #changePasswordModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Por favor, troque sua senha:</h5>
    </div>
    <div class="modal-body">
      <div class="form-group mt-2">
        <p *ngIf="errorMessage.length > 0" class="text-danger">
          {{ errorMessage }}
        </p>
      </div>
      <div class="form-group mb-3">
        <input
          type="password"
          class="form-control"
          id="nova-senha"
          placeholder="Nova senha"
          [(ngModel)]="novaSenha"
        />
      </div>
      <div class="form-group mb-3">
        <input
          type="password"
          class="form-control"
          id="confirmar-nova-senha"
          placeholder="Confirmar nova senha"
          [(ngModel)]="confirmarNovaSenha"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-lg btn-primary btn-pill mx-auto d-block"
        (click)="changePassword()"
      >
        ALTERAR
      </button>
    </div>
  </div>
</ng-template>
<!-- END CHANGE PASSWORD MODAL-->

<ng-template #modalFirstAccess let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Nova senha registrada com sucesso!</h5>
    </div>
    <div class="modal-body">
      <h5>Por favor realize o login novamente!</h5>
    </div>
    <div class="modal-footer text-center">
      <button
        type="submit"
        class="btn btn-lg btn-primary btn-pill mx-auto d-block"
        (click)="resetLogin()"
      >
        FECHAR
      </button>
    </div>
  </div>
</ng-template>
